import {
    GET_AUTHENTICATOR_OTP_REQUEST,
    GET_AUTHENTICATOR_OTP_SUCCESS,
    GET_AUTHENTICATOR_OTP_ERROR,
} from '../actions';

const initialState = {
    isLoading: false,
    otpCodes: [],
    error: null,
};

export default function(state = initialState, action) {
    switch (action.type) {
        case GET_AUTHENTICATOR_OTP_REQUEST:
            return Object.assign({}, state, { isLoading: true, error: null });
        case GET_AUTHENTICATOR_OTP_SUCCESS:
            return Object.assign({}, state, {
                isLoading: false,
                otpCodes: (action.payload.data && action.payload.data.notification) || [],
                error: null,
            });
        case GET_AUTHENTICATOR_OTP_ERROR:
            return Object.assign({}, state, { isLoading: false, error: action.payload });
        default:
            return state;
    }
}
